module.exports = __webpack_public_path__ + "static/team-3-1eb9a388fa63cfdca33784070d6a370d.png";